<template>
  <div>
    <TopBackground :titles="'使用说明'" :smalls="smalls"/>
    <!-- content -->
    <div class="container-s">
      <div class="searchBox">
        <el-input placeholder="输入产品名称" v-model="input3" class="input-with-select">
          <el-button slot="append" type="primary" style="width:100px" @click="search()" >搜索</el-button>
        </el-input>
      </div>
      <div class="insTable">
        <el-table
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column
              prop="title"
              align="center"
              label="标题">
          </el-table-column>
<!--          <el-table-column-->
<!--              prop="type"-->
<!--              align="center"-->
<!--              label="类别">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="models"-->
<!--              align="center"-->
<!--              label="型号">-->
<!--          </el-table-column>-->
          <el-table-column
              prop="productPdf.filename"
              align="center"
              label="说明">
          </el-table-column>
          <el-table-column
              prop="productPdf.modified"
              align="center"
              label="更新日期">
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              width="100"
          >
            <template slot-scope="scope">
              <div>
                <img src="@/assets/icon/unload.png" alt=""  class="unload" @click="upload(scope.row)">
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/util/request";

export default {
  data() {
    return {
      smalls: ['这里，您可以下载有关数字化产品的使用手册或其他相关文档。'],
      input3: '',
      tableData: []
    }
  },
  methods: {
    search() {
      if(!this.input3) {
        this.$message.error('请输入内容查询')
        return
      }
      request.get('/auth/product?name=' + this.input3).then(res => {
        this.tableData = res.data
      })
    },
    upload(item){
      window.open(item.productPdf.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.searchBox {
  width: 600px;
  margin: 0 auto;
  padding: 100px 0;
}

.input-with-select {
  font-size: 18px;
}

.insTable {
  margin-bottom: 100px;

  .unload {
    cursor: pointer;
  }
}

</style>
